import { Box, BoxProps, Divider, Stack } from '@mui/material';
import { ReactNode } from 'react';

type StreamPopupProps = {
  /** Domain body: identity/title, key points, badges, etc. */
  children: ReactNode;
  /** Optional content rendered above the popup body. */
  header?: ReactNode;
  /**
   * Optional row of action buttons. When set, the shell renders a divider and
   * horizontal stack around these children.
   */
  footer?: ReactNode;
  minWidth?: number;
  maxWidth?: number;
  sx?: BoxProps['sx'];
};

/**
 * Shared chrome for stream HoverPopover content with an optional header and
 * footer action row (divider + button stack).
 */
export function StreamPopup({
  children,
  header,
  footer,
  minWidth,
  maxWidth,
  sx,
}: StreamPopupProps) {
  return (
    <Box
      sx={{
        p: 1.25,
        textAlign: 'left',
        ...(minWidth != null ? { minWidth } : null),
        ...(maxWidth != null ? { maxWidth } : null),
        ...sx,
      }}
    >
      {header}
      {children}
      {footer && (
        <>
          <Divider sx={{ my: 1.5 }} />
          <Stack direction="row" spacing={1}>
            {footer}
          </Stack>
        </>
      )}
    </Box>
  );
}
